import { useEffect } from 'react';
import { useShopContext } from '../../context/ShopContext';
import { Store } from '../../types';

export default function StoresTab() {
  const { stores, selectedStore, setSelectedStore, fetchStores, loading, error } = useShopContext();

  useEffect(() => {
    fetchStores();
  }, []);

  const handleSelectStore = (store: Store) => {
    setSelectedStore(store);
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-bold">Stores</h2>
        {/* <button className="bg-primary text-white px-4 py-2 rounded hover:bg-primary-dark">
          Add Store
        </button> */}
      </div>
      {loading && <p>Loading stores...</p>}
      {error && <p className="text-red-600">{error}</p>}
      {!loading && !error && stores.length === 0 && <p>No stores available.</p>}
      {!loading && !error && stores.length > 0 && (
        <div className="space-y-4">
          {stores.map((store) => (
            <div key={store.id} className="border rounded-lg p-4">
              <div className="flex justify-between items-center mb-2">
                <h3 className="font-bold">{store.name} {selectedStore?.id === store.id && <span className="text-green-600 text-sm">(Active)</span>}</h3>
                <button
                  onClick={() => handleSelectStore(store)}
                  className={`px-3 py-1 rounded text-sm ${selectedStore?.id === store.id ? 'bg-gray-200' : 'bg-primary text-white hover:bg-primary-dark'}`}
                >
                  {selectedStore?.id === store.id ? 'Selected' : 'Select'}
                </button>
              </div>
              <p className="text-sm text-gray-600 mb-3">Owner: {store.owner.email}</p>
              <h4 className="font-semibold text-sm mb-2">Branches:</h4>
              {store.branches?.length ? (
                <ul className="list-disc pl-5 text-sm">
                  {store.branches.map((branch) => (
                    <li key={branch.id}>{branch.name} (Manager: {branch.manager?.email || 'None'})</li>
                  ))}
                </ul>
              ) : (
                <p className="text-sm text-gray-500">No branches</p>
              )}
              <button className="text-primary hover:text-primary-dark text-sm mt-2">
                Edit Store
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}